import {Component} from '@angular/core';

@Component({
  selector: 'app-agb',
  templateUrl: './agb.component.html',
  styleUrl: './agb.component.css'
})
export class AgbComponent {

}
